/**
 * Hybrid Fieldset Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import * as React from "react";
import Box from "@sproutsocial/seeds-react-box";
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import { ChildContainer } from "./styles"; // Styled-components version
import { FieldsetLegend, FieldsetHelperText } from "./FieldsetParts";
import { FieldsetTailwind } from "./FieldsetTailwind"; // Tailwind version
import type { TypeFieldsetProps } from "./FieldsetTypes";

const FieldsetHybrid = ({
  layout = "vertical",
  label,
  helperText,
  children,
  ...rest
}: TypeFieldsetProps) => {
  if (hasStyledProps(rest)) {
    // Legacy styled-components tree — identical to the pre-migration Fieldset body
    return (
      <Box as="fieldset" border="none" p={0} data-qa-fieldset="" {...rest}>
        {typeof label === "string" ? (
          <FieldsetLegend>{label}</FieldsetLegend>
        ) : (
          label
        )}
        {typeof helperText === "string" ? (
          <FieldsetHelperText>{helperText}</FieldsetHelperText>
        ) : (
          helperText
        )}
        <Box
          display="flex"
          flexDirection={layout === "vertical" ? "column" : "row"}
        >
          {React.Children.map(children, (child) => (
            <ChildContainer layout={layout}>{child}</ChildContainer>
          ))}
        </Box>
      </Box>
    );
  }

  // Use Tailwind version (preferred - better performance)
  return (
    <FieldsetTailwind
      layout={layout}
      label={label}
      helperText={helperText}
      {...rest}
    >
      {children}
    </FieldsetTailwind>
  );
};

FieldsetHybrid.displayName = "Fieldset";
export default FieldsetHybrid;
